module.exports = __webpack_public_path__ + "static/img/my_pic.9ce4a7d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/my_pic.jpg
// module id = 99
// module chunks = 1